"use strict";

exports.__esModule = true;
exports["default"] = Download;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Download(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.601 16.078l-.06-14.54C14.533.713 15.269.05 16.095.063c.827.012 1.438.697 1.449 1.521l.058 14.538 6.245-6.225c.58-.576 1.525-.56 2.117.033.595.595.607 1.537.031 2.113l-8.774 8.747a1.442 1.442 0 0 1-.482.307c-.175.076-.37.117-.568.113a1.581 1.581 0 0 1-.584-.128 1.704 1.704 0 0 1-.486-.323l-8.653-8.661a1.548 1.548 0 0 1-.463-1.066c-.004-.391.14-.768.436-1.051.572-.576 1.521-.56 2.117.033l6.064 6.064zM28.45 31.937H3.54c-.887 0-1.603-.72-1.603-1.603V22.86a1.6 1.6 0 0 1 1.603-1.599 1.6 1.6 0 0 1 1.599 1.599v5.873H26.85V22.86a1.6 1.6 0 0 1 1.599-1.599 1.6 1.6 0 0 1 1.603 1.599v7.474c0 .883-.716 1.603-1.603 1.603z"
  }));
}